{
  "name": "qmulus-app",
  "version": "2.4.26",
  "private": true,
  "type": "module",
  "scripts": {
    "dev": "yarn g:dev",
    "generate:mime-db": "cd $INIT_CWD && tsx scripts/generate-mime-type-db.ts",
    "build:route:ts": "cd $INIT_CWD && tsx scripts/generate-route-type.ts",
    "build:dev": "cd $INIT_CWD && yarn build:route:ts && vite build --mode=staging",
    "build:prod": "cd $INIT_CWD && yarn build:route:ts && vue-tsc && vite build",
    "test:e2e": "cd $INIT_CWD && playwright test --project=chromium",
    "test:e2e:dev": "NODE_ENV=development yarn test:e2e",
    "screenshots:capture": "cd $INIT_CWD && playwright test --project=screenshot-capture",
    "screenshots:capture:dev": "NODE_ENV=development yarn screenshots:capture",
    "zeus:generate": "cd $INIT_CWD && zeus ./src/generated/schema.graphql ./src/generated/zeus",
    "tsc": "yarn g:tsc",
    "lint": "yarn g:lint",
    "lint:fix": "yarn g:lint:fix",
    "lint:js": "yarn g:lint:js",
    "lint:js:fix": "yarn g:lint:js:fix",
    "lint:css": "yarn g:lint:css",
    "lint:css:fix": "yarn g:lint:css:fix",
    "test:prod": "yarn g:test:prod",
    "test:ci": "yarn g:test:ci",
    "test:dev": "yarn g:test:dev"
  },
  "dependencies": {
    "@fortawesome/fontawesome-free": "^6.4.0",
    "@qmulus/primevue-theme": "workspace:*",
    "@qmulus/ui": "workspace:*",
    "@sentry/vite-plugin": "^4.5.0",
    "@sgratzl/chartjs-chart-boxplot": "^4.4.0",
    "@vee-validate/zod": "^4.12.7",
    "@vue/reactivity": "^3.2.47",
    "base64-js": "^1.5.1",
    "chart.js": "^4.5.0",
    "chartjs-adapter-dayjs-4": "^1.0.4",
    "chartjs-plugin-annotation": "^3.0.1",
    "chartjs-plugin-zoom": "^2.1.0",
    "d3": "^7.8.4",
    "graphql-zeus": "^7.0.4",
    "lodash.clonedeep": "^4.5.0",
    "lodash.isequal": "^4.5.0",
    "lodash.merge": "^4.6.2",
    "markdown-it": "^14.1.1",
    "pinia": "^3.0.4",
    "qs": "^6.14.2",
    "quill": "^1",
    "rrule": "^2.7.2",
    "socket.io-client": "^4.8.3",
    "uuid": "^9.0.0",
    "vee-validate": "^4.10.5",
    "vue-cal": "^4.8.1",
    "vue-chartjs": "^4.1.1",
    "vue-simple-calendar": "^7.2.1",
    "vuedraggable": "^4.1.0",
    "vuex": "^4.1.0"
  },
  "devDependencies": {
    "@playwright/test": "^1.58.2",
    "@qmulus/frontend-shared": "workspace:^",
    "@types/lodash.clonedeep": "^4.5.9",
    "@types/lodash.isequal": "^4.5.8",
    "@types/lodash.merge": "^4",
    "@types/markdown-it": "^14.1.2",
    "@types/mime-db": "^1",
    "@types/pixelmatch": "^5.2.6",
    "@types/pngjs": "^6.0.5",
    "@types/qs": "^6.9.7",
    "@vueuse/core": "^10.4.1",
    "autoprefixer": "^10.4.19",
    "mime-db": "^1.54.0",
    "pixelmatch": "^7.2.0",
    "pngjs": "^7.0.0",
    "tailwindcss": "^3.4.3",
    "vue-component-type-helpers": "^3.1.8",
    "vue-unused-components-checker": "^1.1.2"
  }
}
